import { IComponentOptions } from "angular"
import { GamingRelationshipEditComponentController } from "./controller"

export const vsComponentName = "gamingRelationshipEditComponent"

export const gamingRelationshipEditComponentOptions: IComponentOptions = {
  controller: GamingRelationshipEditComponentController,
  controllerAs: "gamingRelationshipEditController",
  template: require("!html-loader!./index.html").default,
  bindings: {
    "model": "<",
    "contract": "<"
  }
}